document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('details[id^="Details-collapsible_tab"]').forEach(function(acc) {
        acc.setAttribute('open', 'open');
        const summary = acc.querySelector('summary');
        if (summary) {
        summary.setAttribute('aria-expanded', 'true');
        }
    });

   document.querySelectorAll('details[id^="Details-collapsible_tab"]').forEach(function(d){
    // get visible text inside summary/title and content
    var summaryText = (d.querySelector('summary') && d.querySelector('summary').innerText || '').trim();
    var contentText = (d.querySelector('.accordion__content') && d.querySelector('.accordion__content').innerText || '').trim();
    // If both are empty — remove/hide element

    if (summaryText === '' && contentText === '') {
      d.remove(); // or: d.style.display = 'none';
    }
   });

  document.querySelectorAll('.product__accordion.accordion.quick-add-hidden').forEach(function (acc) {
    const text = acc.innerText.trim();
    if (text === "" || text.length < 3) {
      acc.remove();
    }
  });
});


document.addEventListener('click', function(e){
var btn = e.target.closest && e.target.closest('.wb-video-poster');
if (!btn) return;
var yid = btn.getAttribute('data-yid') || (btn.closest('.wb-video-block') && btn.closest('.wb-video-block').dataset.yid);
if (!yid) return;

var wrapper = document.createElement('div');
wrapper.className = 'wb-video-wrapper';

var iframe = document.createElement('iframe');
var params = ['autoplay=1','rel=0','modestbranding=1','playsinline=1'].join('&');

iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(yid) + '?' + params;
iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
iframe.setAttribute('allowfullscreen','true');
iframe.className = 'wb-video-iframe';

wrapper.appendChild(iframe);

var block = btn.closest('.wb-video-block');
block.innerHTML = '';
block.appendChild(wrapper);

setTimeout(function(){ try{ iframe.focus(); }catch(e){} }, 300);
});